import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import * as actionCreators from 'store/actions';
import Input from 'components/atoms/Inputs/Input';
import Typography from '@material-ui/core/Typography';
import ButtonPrimary from 'components/atoms/Buttons/ButtonPrimary';
import { Validators } from 'components/atoms/Inputs/Validators';
import SelectImput from 'components/atoms/Inputs/SelectInput';
import SelectInputIcon from 'components/atoms/Inputs/SelectInputIcon';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import CloseButton from 'components/atoms/Buttons/CloseButton';
import avatar from 'assets/no-photo.png';
import { useHistory } from 'react-router-dom';
import Loading from 'components/atoms/Loading/Loading';
import pdfLogo from 'assets/pdfLogo.svg';

const URLBASE = process.env.REACT_APP_URL_BASE;

const URLAPI = process.env.REACT_APP_URL_API;

const Wrapper = styled.div`
  position: relative;
  display: block;
  margin: 16px auto;
  min-width: 120px;
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
`;

const FormWrapper = styled.div`
  margin: 16px 0;
  display: flex;
  background-color: #ffffff;
  color: #fff;
  z-index: 1;
  width: 100%;
`;
const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const SingleInputWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
  ${({ border }) =>
    border &&
    css`
      border: 1px solid #c4c4c4;
      border-radius: 0 0 4px 4px;
      border-top: 0;
      margin-bottom: 20px;
    `}
  ${({ file }) =>
    file &&
    css`
      width: 210px;
    `}
  ${({ imgBox }) =>
    imgBox &&
    css`
      width: 210px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-color: #c4c4c4;
    `}
  ${({ noMarginB }) =>
    noMarginB &&
    css`
      margin-bottom: 0;
    `}
`;

const BtnHolder = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

const useStyles = makeStyles(theme => ({
  button: {
    width: '100%',
    borderRadius: '4px 4px 0 0',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const ImgWrapper = styled.div`
  width: 48%;
`;
const ProductImg = styled.img`
  width: 72px;
  height: auto;
  margin: 12px;
`;

const ProductName = styled.div`
  color: ${({ theme }) => theme.palette.common.black};
`;

const initialState = {
  productName: '',
  oldProductName: '',
  shortName: '',
  price: '',
  oldPrice: '',
  productSubName: '',
  image: '',
  currency: '',
  language: '',
  productLang: '',
  type: '',
  quantity: '',
  description: '',
  listTitle: '',
  listElements: '',
  tmpImgURL: '',
  avatarImg: true,
  file: null,
  temporaryImage: null,
  oldImage: null,
  newImage: null,
  tmpPdf: '',
  avatarPdf: false,
  pdf: '',
  pdfName: '',
  category: '',
};

const selectValues = [
  { value: 1, name: 'PDF' },
  { value: 2, name: 'VIDEO' },
];

const productsCategories = [
  { value: 'fde18974-b712-4eb8-a650-1b848f4e015a', category: 'Dieta' },
  { value: 'b3453c5-4cb3-4f0f-be1f-2a05fdf55d86', category: 'Suplement' },
  { value: '87e83e6a-5143-46f2-9c46-d3a33131e3ce', category: 'Wiedza' },
  { value: '8337cbe2-653e-4d50-b400-58cd4ab5cf40', category: 'Trening' },
];

const EditProducts = ({
  onInitValidators,
  unieqeNames,
  onFetchCountries,
  countries,
  onFetchSingleproduct,
  product,
  match,
  onSubmitProductsForm,
}) => {
  const [state, setState] = useState(initialState);
  const [numbersOFListElements, setNumbersOFListElements] = useState([0]);
  const [isError, setError] = useState({
    isError: {
      productName: null,
    },
  });
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    if (countries.length === 0) {
      onFetchCountries();
    }
  }, [countries]);

  useEffect(() => {
    const endpoint = `${URLAPI}product/name`;
    onInitValidators(endpoint, 'userEmail');
  }, []);

  useEffect(() => {
    onFetchSingleproduct(match.params.id);
  }, []);

  useEffect(() => {
    if (product !== null && countries !== undefined) {
      setState({
        ...state,
        productName: product.name,
        oldProductName: product.name,
        shortName: product.short_name,
        price: product.price,
        productSubName: product.subname,
        oldImage: product.image,
        currency: countries.filter(el => el.currency_code === product.currency)[0],
        language: countries.filter(el => el.lang === product.language)[0],
        type: selectValues.filter(el => el.name === product.type)[0] || null,
        description: product.description,
        listTitle: product.list_title,
        listElements: product.list_elements,
        quantity: product.quantity,
        category: productsCategories.filter(category => category.value === product.category_product_id)[0],
        productLang: product.product_lang,
        oldPrice: product.price_old,
        pdfName: product.ebook_name,
      });
    }
  }, [product, countries]);

  const isValidationPassed = () => {
    return true;
  };
  const inputValidation = error => {
    if (error) {
      setError({ isError: { productName: error.error } });
    } else {
      setError({ isError: { productName: true } });
    }
  };
  const handleChangeInput = e => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeListElInput = e => {
    const { listElements } = { ...state };
    const currentState = listElements;

    currentState[e.target.name] = e.target.value;
    setState({
      ...state,
      listElements: currentState,
    });
  };

  const handleChangeSelect = (e, key) => {
    setState({
      ...state,
      [key]: e,
    });
  };
  const handleChangeSelectCategory = (e, key) => {
    setState({
      ...state,
      [key]: e.value,
    });
  };

  const resetForm = () => {
    setState(initialState);
    history.push('/products');
  };

  const handleSubmit = e => {
    e.preventDefault();

    const listToJson = JSON.stringify(state.listElements);
    const bodyFormData = new window.FormData();
    bodyFormData.set('name', state.productName);
    bodyFormData.set('subname', state.productSubName);
    bodyFormData.set('short_name', state.shortName);
    bodyFormData.set('price', state.price);
    bodyFormData.set('price_old', state.oldPrice);
    bodyFormData.set('currency', state.currency.currency_code);
    bodyFormData.set('language', state.language.iso_3166_2);
    bodyFormData.set('product_lang', state.language.iso_3166_2);
    bodyFormData.set('description', state.description);
    bodyFormData.set('list_title', state.listTitle);
    bodyFormData.set('list_elements', listToJson);
    bodyFormData.set('quantity', state.quantity);
    bodyFormData.set('category_product_id', state.category);
    bodyFormData.set('_method', 'PUT');
    if (state.type !== null) {
      bodyFormData.set('type', state.type?.name);
    }
    if (state.file !== null) {
      bodyFormData.append('image', state.file);
    }
    if (state.pdf !== '') {
      bodyFormData.set('ebook', state.pdf);
      bodyFormData.set('file_name', state.pdfName);
    }

    onSubmitProductsForm(match.params.id, bodyFormData, resetForm);
  };

  const onAddElement = e => {
    setNumbersOFListElements([...numbersOFListElements, numbersOFListElements.length]);
  };

  const handleChangeFile = e => {
    const reader = new window.FileReader();
    reader.onload = () => {
      const dataURL = reader.result;

      setState(state => ({
        ...state,
        temporaryImage: dataURL,
      }));
    };

    setState(state => ({
      ...state,
      file: e.target.files[0],
      avatarImg: false,
    }));
  };

  const removeImg = () => {
    setState({
      ...state,
      temporaryImage: null,
      oldImage: null,
      file: null,
    });
  };

  const handleChangePdf = e => {
    const reader = new window.FileReader(e);
    reader.onload = e => {
      const dataURL = reader.result;

      setState(state => ({
        ...state,
        tmpPdf: dataURL,
      }));
    };

    setState(state => ({
      ...state,
      pdf: e.target.files[0],
      pdfName: e.target.files[0].name,
      avatarPdf: false,
    }));
  };

  const removePdf = () => {
    setState({
      ...state,
      pdf: '',
      avatarPdf: true,
      pdfName: '',
      tmpPdf: '',
    });
  };

  const onCloseHandler = () => {
    resetForm();
    history.push('/products');
  };
  useEffect(() => {
    if (state.listElements?.length > 0) {
      const numberOfinputs = [];
      for (let i = 0; i < state.listElements?.length; i++) {
        numberOfinputs.push(i);
      }
      setNumbersOFListElements(numberOfinputs);
    }
  }, [state.listElements]);

  const currentPhoto = () => {
    let image = '';
    if (state.file !== null) {
      image = <ProductImg src={URL.createObjectURL(state.file)} alt="product" />;
    } else if (state.oldImage !== null) {
      image = <ProductImg src={`${URLBASE}storage/${state.oldImage}`} alt="product" />;
    } else {
      image = <ProductImg src={avatar} alt="product" />;
    }
    return image;
  };

  if (state.productName === undefined && product === null) {
    return <Loading />;
  }
  return (
    < Wrapper >
      <BtnHolder>
        <CloseButton handleClick={onCloseHandler} />
      </BtnHolder>
      <Typography variant="h5" color="primary">
        Edytuj produkt
      </Typography>
      <FormWrapper>
        <StyledForm onSubmit={e => handleSubmit(e)}>
          <SingleInputWrapper>
            <Input
              onChange={handleChangeInput}
              uniqueNames={unieqeNames}
              htmlFor="productName"
              label="Nazwa"
              name="productName"
              id="productName"
              type="text"
              value={state.productName}
              oldValue={state.oldProductName}
              isError={isError}
              handleOnBlur={isValidationPassed}
              inputValidation={inputValidation}
              validators={[
                { check: Validators.required, message: 'pole wymagane' },
                { check: Validators.uniqueNameEdit, message: 'Produkt o podanej nazwie już  istnieje' },
              ]}
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <Input
              onChange={handleChangeInput}
              uniqueNames={unieqeNames}
              htmlFor="productSubName"
              label="Nazwa podrzędna"
              name="productSubName"
              id="productSubName"
              type="text"
              value={state.productSubName}
              isError={isError}
              handleOnBlur={isValidationPassed}
              inputValidation={inputValidation}
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <SelectImput
              options={productsCategories}
              val={state.category}
              optionType="category"
              noOptionsText="Brak danych"
              label="Kategoria produktu"
              handleOnChange={handleChangeSelectCategory}
              onChangeParams={['category']}
              id="category"
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <Input
              onChange={handleChangeInput}
              htmlFor="shortName"
              label="Skrócona nazwa"
              name="shortName"
              id="shortName"
              type="text"
              value={state.shortName}
              isError={isError}
              handleOnBlur={isValidationPassed}
              inputValidation={inputValidation}
            />
          </SingleInputWrapper>
          <ImgWrapper>
            <SingleInputWrapper noMarginB file>
              <label styles={{ width: '100%' }} htmlFor="raised-button-file">
                <input
                  accept="image/*"
                  className={classes.input}
                  style={{ display: 'none' }}
                  id="raised-button-file"
                  multiple
                  type="file"
                  onChange={event => handleChangeFile(event)}
                />
                <Button variant="outlined" component="span" className={classes.button} full-width>
                  Dodaj zdjęcie
                </Button>
              </label>
            </SingleInputWrapper>
            <SingleInputWrapper file imgBox border>
              {currentPhoto()}
              {state.oldImage || state.temporaryImage !== null ? (
                <CloseButton handleClick={removeImg} />
              ) : (
                  ''
                )}
            </SingleInputWrapper>
          </ImgWrapper>

          <SingleInputWrapper>
            <Input
              onChange={handleChangeInput}
              htmlFor="price"
              label="Cena upsell"
              name="price"
              id="price"
              type="number"
              value={state.price}
              isError={isError}
              handleOnBlur={isValidationPassed}
              inputValidation={inputValidation}
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <Input
              onChange={handleChangeInput}
              htmlFor="oldPrice"
              label="Cena Panel użytkownika"
              name="oldPrice"
              id="oldPrice"
              type="number"
              value={state.oldPrice}
              isError={isError}
              handleOnBlur={isValidationPassed}
              inputValidation={inputValidation}
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <SelectInputIcon
              options={countries}
              val={state.currency}
              optionType="currency_code"
              disabledOption={option =>
                option.currency === '' || option.currency_code === '' || option.currency === null
              }
              noOptionsText="Nie znaleziono"
              label="Waluta"
              handleOnChange={handleChangeSelect}
              onChangeParams={['currency']}
              name="currency"
              id="currency"
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <SelectImput
              options={selectValues}
              val={state.type}
              optionType="name"
              noOptionsText="Brak danych"
              label="Typ pliku"
              handleOnChange={handleChangeSelect}
              onChangeParams={['type']}
              id="type"
            />
          </SingleInputWrapper>
          {state.type?.value === 1 && (
            <ImgWrapper>
              <SingleInputWrapper noMarginB file>
                <label styles={{ width: '100%' }} htmlFor="pdf">
                  <input
                    accept="application/pdf"
                    className={classes.input}
                    style={{ display: 'none' }}
                    id="pdf"
                    multiple
                    type="file"
                    onChange={event => handleChangePdf(event)}
                  />
                  <Button variant="outlined" component="span" className={classes.button} full-width>
                    Dodaj plik
                  </Button>
                </label>
              </SingleInputWrapper>
              <SingleInputWrapper file imgBox border>
                {state.avatarPdf ? (
                  <ProductImg src={pdfLogo} alt="empty" />
                ) : (
                    <>
                      <ProductImg src={pdfLogo} alt="empty" />
                      <ProductName>{state.pdf.name}</ProductName>

                      <CloseButton handleClick={e => removePdf(e)} />
                    </>
                  )}
              </SingleInputWrapper>
            </ImgWrapper>
          )}
          <SingleInputWrapper>
            <Input
              onChange={handleChangeInput}
              htmlFor="quantity"
              label="Ilość (stron, dł. video)"
              name="quantity"
              id="quantity"
              type="text"
              value={state.quantity}
              isError={isError}
              handleOnBlur={isValidationPassed}
              inputValidation={inputValidation}
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <SelectInputIcon
              options={countries}
              val={state.language}
              optionType="country"
              disabledOption={option => option.name === ''}
              noOptionsText="Nie znaleziono"
              label="Język"
              handleOnChange={handleChangeSelect}
              onChangeParams={['language']}
              name="country"
              id="country"
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <Input
              id="description"
              onChange={handleChangeInput}
              value={state.description}
              // htmlFor={name}
              label="Opis produktu"
              name="description"
              type="text"
              multiline
              inputProps={{ rows: 5 }}
              htmlFor="description"
            />
          </SingleInputWrapper>
          <SingleInputWrapper>
            <Input
              id="listTitle"
              onChange={handleChangeInput}
              value={state.listTitle}
              // htmlFor={name}
              label="Nagłówek listy"
              name="listTitle"
              type="text"
              htmlFor="listTitle"
            />
          </SingleInputWrapper>
          {numbersOFListElements.map((el, index) => (
            <SingleInputWrapper key={el}>
              <Input
                onChange={handleChangeListElInput}
                value={state.listElements[index]}
                label="Element listy"
                name={index}
                type="text"
                htmlFor="listEl"
              />
            </SingleInputWrapper>
          ))}
          <SingleInputWrapper>
            <ButtonPrimary handleClick={onAddElement}>Dodaj Element</ButtonPrimary>
          </SingleInputWrapper>

          <ButtonWrapper>
            <ButtonPrimary type="submit">Zapisz Zmiany</ButtonPrimary>
          </ButtonWrapper>
        </StyledForm>
      </FormWrapper>
    </Wrapper >
  );
};

const mapStateToProps = state => {
  return {
    unieqeNames: state.validators.validators,
    countries: state.countries.countries,
    product: state.products.singleProducts,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchSingleproduct: id => dispatch(actionCreators.fetchSingleproduct(id)),
    onInitValidators: (endpoint, key) => dispatch(actionCreators.initValidators(endpoint, key)),
    onSubmitProductsForm: (id, bodyFormData, resetForm) =>
      dispatch(actionCreators.submitProductsForm(id, bodyFormData, resetForm)),
    onFetchCountries: () => dispatch(actionCreators.fetchCountries()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditProducts);
